export default __webpack_public_path__ + "static/media/cryptocom.f30196eb.svg";